import { ChevronDownIcon } from "@heroicons/react/16/solid";
import { useState, useRef, useEffect } from "react";
import clsx from "clsx";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { formatCrypto, formatCurrency } from "../../utils";

const pairs = [
  { id: "btc", pair: "BTC/USDT", price: "100,000.00" },
  { id: "eth", pair: "ETH/USDT", price: "3,437.89" },
  { id: "xrp", pair: "XRP/USDT", price: "2.24980" },
  { id: "sol", pair: "SOL/USDT", price: "194.078" },
  { id: "doge", pair: "DOGE/USDT", price: "0.32538" },
];

const DropdownPair = ({
  label = "Pair",
  placeholder = "Select Pair",
  value,
  onChange,
  moreContent,
  options,
  disabled,
  loading,
}) => {
  const [dataOptions, setDataOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [position, setPosition] = useState("bottom");
  const boxRef = useRef(null);

  useEffect(() => {
    if (options?.length) {
      setDataOptions(options);
    } else {
      setDataOptions([]);
    }
  }, [options]);

  const filteredPairs = dataOptions.filter((p) =>
    p.pair.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (pair) => {
    onChange(pair);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen && boxRef.current) {
      const boxRect = boxRef.current.getBoundingClientRect();
      const dropdownHeight = 300;
      const spaceBelow = window.innerHeight - boxRect.bottom;
      const spaceAbove = boxRect.top;

      setPosition(
        spaceBelow < dropdownHeight && spaceAbove > dropdownHeight
          ? "top"
          : "bottom"
      );
    }

    if (!isOpen) {
      setSearch("");
    }
  }, [isOpen]);

  return (
    <div className="relative w-full mt-5" ref={boxRef}>
      <div
        className="rounded-[10px] relative cursor-pointer"
        // className="border border-gray-300 rounded-[10px] p-4 relative cursor-pointer"
        onClick={() => (!disabled ? setIsOpen((prev) => !prev) : {})}
      >
        <label className="block text-xs text-gray-500 mb-1">{label}</label>

        <div
          className={`w-full p-[12px] mt-[10px] rounded-[10px] text-sm border-none bg-[#F2F4F8]  shadow-[0px_1.5px_1px_#C1C7CD] relative ${
            disabled && "!bg-[#C7C7C7] text-gray-400 cursor-default"
          }`}
        >
          {/* <div className="flex justify-between items-center relative"> */}
          <span
            className={`font-bold text-gray-900 ${
              disabled && "!text-gray-400"
            }`}
          >
            {value?.pair || placeholder}
          </span>
          {/* <ChevronDownIcon className="absolute w-[24px] h-[24px] right-0 top-[50%] translate-y-[-50%]" /> */}
          <ChevronDownIcon className="absolute w-[24px] h-[24px] right-4 top-[50%] translate-y-[-50%]" />
        </div>
        {moreContent && <div className="mt-3">{moreContent}</div>}
      </div>
      {/* <div
        className="border border-gray-300 rounded-[10px] p-4 relative cursor-pointer"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <label className="block text-xs text-gray-500 mb-1">{label}</label>

        <div className="flex justify-between items-center relative">
          <span className="text-base md:text-xl font-bold text-gray-900">
            {value?.pair || placeholder}
          </span>
          <ChevronDownIcon className="absolute w-[24px] h-[24px] right-0 top-[50%] translate-y-[-50%]" />
        </div>
        {moreContent && <div className="mt-3">{moreContent}</div>}
      </div> */}

      {isOpen && (
        <div
          className={clsx(
            "absolute w-full z-10 bg-white border border-gray-200 rounded-xl shadow-[0px_0px_10px_#0002] max-h-[300px]  p-2  py-2 pb-5",
            position === "top" ? "bottom-full mb-2" : "mt-2"
          )}
        >
          <div className="p-3 px-4 bg-[#F2F4F8] flex items-center  rounded-lg gap-3">
            <MagnifyingGlassIcon className="w-[18px] h-[18px]" />
            <input
              type="text"
              placeholder="Enter search term"
              className="w-full border rounded-md p-0 text-sm border-none !bg-transparent outline-none"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-2 font-semibold text-sm border-b mt-4 py-2 px-3 text-gray-500">
            <div>Pair</div>
            <div>Price</div>
          </div>

          <div className="overflow-auto no-scrollbar max-h-[160px]">
            {loading ? (
              <span className="w-full text-center text-gray-400 block text-sm pt-4">
                Loading get data...
              </span>
            ) : filteredPairs?.length ? (
              filteredPairs.map((item) => (
                <div
                  key={item.id}
                  className={clsx(
                    "grid grid-cols-2 px-3 py-2 hover:rounded-[10px] text-sm cursor-pointer hover:bg-gray-100 mt-2",
                    value?.id === item.id && "bg-gray-100 rounded-[10px]"
                  )}
                  onClick={() => handleSelect(item)}
                >
                  <div className="font-medium">{item.pair}</div>
                  <div>
                    {formatCrypto(!!item?.price ? Number(item?.price) : 0)}
                    &nbsp;{item?.base_currency || "USDT"}
                  </div>
                </div>
              ))
            ) : (
              <span className="w-full text-center text-gray-400 block text-sm pt-4">
                No Data
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownPair;
